export const CLICK = 'click';
export const OPEN = 'open';
export const CLOSE = 'close';
export const CANCEL = 'cancel';
export const SEND = 'send';
export const CHANGE = 'change';
